<template>
  <c-row>
    <c-col col="3">
      <c-card>
        <loader v-show="loading" />
        <c-card-header>
          <c-card-title>
            <strong>Tambah Mutasi</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Bank Account</label>
            <select-x
              url="/api/v1/bank-account"
              size="20"
              placeholder="Silahkan Pilih Bank"
              label="name"
              v-model="history.bank"
              @input="changeBank"
              v-bind:class="{ 'has-error': errors.bank_account_id }"
            />
          </div>
          <div class="form-group">
            <label>COA</label>
            <select-x
              :url="`/api/v1/coa`"
              v-model="history.coa"
              placeholder="Pilih COA"
            />
          </div>
          <div class="form-group">
            <label>Tanggal</label>
            <datetime
              type="datetime"
              v-model="history.created_at"
              class="date-control"
            />
          </div>
          <div class="form-group">
            <label>Jenis</label>
            <select2
              :items="kasFlow"
              placeholder="Pilih Jenis"
              label="abc"
              v-model="history.type"
              v-bind:class="{ 'has-error': errors.type }"
            />
          </div>
          <div class="form-group">
            <label>Nilai</label>
            <input
              type="number"
              class="form-control right"
              v-model="history.amount"
              v-bind:class="{ 'has-error': errors.amount }"
            />
          </div>
          <div class="form-group">
            <label>Penjelasan</label>
            <input
              type="text"
              class="form-control"
              v-model="history.description"
              v-bind:class="{ 'has-error': errors.description }"
            />
          </div>
          <div class="form-group">
            <label>Keterangan</label>
            <input
              type="text"
              class="form-control"
              v-model="history.notes"
              v-bind:class="{ 'has-error': errors.notes }"
            />
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-success" @click="addTransaction">
            <i class="cil-save"></i> Save
          </button>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="9">
      <c-card>
        <loader v-show="loading" />
        <c-card-body>
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="kettikkan untuk mencari kemudian enter"
              v-model="keyword"
              @keyup="search"
            />
          </div>
          <div style="overflow: auto">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Tanggal</th>
                  <th>Penjelasan Transaksi</th>
                  <th>Keterangan</th>
                  <th>Bank</th>
                  <th>Debit</th>
                  <th>Kredit</th>
                  <th>Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in cashHistory.data" :key="k">
                  <td>{{ d.created_at | dateTimeFormat }}</td>
                  <td>
                    {{ d.description }}
                    <span class="label label-success" v-show="d.coa_name">{{
                      d.coa_name
                    }}</span>
                  </td>
                  <td>{{ d.notes }}</td>
                  <td>{{ d.bank_name }}</td>
                  <td class="right">{{ d.debit | thousandSeparator }}</td>
                  <td class="right">{{ d.credit | thousandSeparator }}</td>
                  <td class="right">{{ d.balance | thousandSeparator }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <paginator :paginator="cashHistory.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import Select2 from "../../components/Select2";
import SelectX from "../../components/SelectX";
import Paginator from '../../components/Paginator.vue';
import Loader from '../../components/Loader.vue';
export default {
  components: {
    select2: Select2,
    Paginator,
    Loader,
    SelectX,
  },
  data () {
    return {
      kasFlow: ["debit", "credit"],
      loading: true,
      history: {
      },
      cashHistory: {},
      errors: [],
      keyword: ''
    };
  },
  created () {
    this.history.created_at = moment().format();
    const query = this.$route.query;
    if (query && query.acc) {
      this.getDefaultBankAccount(query.acc);
    } else {
      this.getDefaultBankAccount(4);
    }
  },
  methods: {
    histories (page, accountId) {
      this.loading = true;
      HTTPAUTH.get(`/api/v1/bank-history?b=${accountId}&page=${page}&size=10&q=${this.keyword}`)
        .then(res => {
          this.$router.push({ query: { acc: accountId, page: page, q: this.keyword } }).catch(() => { })
          this.cashHistory = res.data;
          this.disableLoading();
        })
        .catch(() => {
          this.disableLoading();
        });
    },
    getDefaultBankAccount (id) {
      if (!id) {
        id = 4;
      }
      HTTPAUTH.get(`/api/v1/bank-account/${id}`).then(res => {
        this.history.bank = res.data.data;
        const bank = this.history.bank;
        this.histories(1, bank.id);
      })
    },
    disableLoading () {
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    search (e) {
      if (e.keyCode == 13) {
        var bankId = this.getBankId()
        this.histories(1, bankId)
      }
    },
    getBankId () {
      if (this.history.bank) {
        return this.history.bank.id;
      }
      return '';
    },
    changePage (page) {
      this.histories(page, this.getBankId())
    },
    addTransaction () {
      if (this.history.bank) {
        this.history.bank_account_id = this.history.bank.id
      }
      if (this.history.coa) {
        this.history.coa_id = this.history.coa.id
      }
      HTTPAUTH.post("/api/v1/bank-history", this.history)
        .then(() => {
          this.history = {
            created_at: moment()
          };
          this.getDefaultBankAccount(this.history.bank_account_id);
        })
        .catch(eres => {
          if (eres.response.data.message) {
            this.$toasted.error(eres.response.data.message).goAway(2000);
            this.errors = eres.response.data.errors;
            return;
          }
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    changeBank (b) {
      if (b) {
        this.histories(1, b.id)
        return;
      }
      this.histories(1, '')
    }
  }
};
</script>